import type { StaticStackItem } from "AdminPanel/Spine/lib/staticLayerStack";
import { captureStaticStackFramesOnly } from "AdminPanel/Spine/editor/export/components/export-animation/utils/exportFrames";
import { blobToDataURL } from "AdminPanel/Spine/editor/create-avatar/blobToDataURL";

/** 将静态叠层合成单帧 webp data URL（全静态导出用，不编 VAP） */
export async function compositeStaticStackToWebpDataUrl(
  staticStackItems: StaticStackItem[],
  outputSize = 512,
): Promise<string> {
  const imgItems = staticStackItems.filter(
    (i): i is Extract<StaticStackItem, { kind: "img" }> => i.kind === "img",
  );
  if (imgItems.length === 0) {
    throw new Error("没有可导出的静态图层");
  }

  const { frames } = await captureStaticStackFramesOnly({
    staticStackItems: imgItems,
    outputSize,
    fps: 1,
    durationMs: 1,
    maxFrames: 1,
    transparentBackground: true,
  });
  const canvas = frames[0]?.canvas;
  if (!canvas) {
    throw new Error("静态合成失败");
  }

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (b) => (b ? resolve(b) : reject(new Error("canvas.toBlob 返回 null"))),
      "image/webp",
      0.92,
    );
  });
  return blobToDataURL(blob);
}
